module.exports = __webpack_public_path__ + "img/kerala_wayanad_camp.0bc12ad3.jpg";